<!--
 * @FileDescription: 销售账单
 * @Author: 陈文景
 * @Date: 2022-12-27 09:34:13
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-tabs v-model="active" @tab-click="handleClickTabs">
    <el-tab-pane label="已出账" name="issued">
      <Issued ref="issued" />
    </el-tab-pane>

    <el-tab-pane label="未出账" name="unpublished">
      <Unpublished ref="unpublished" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Issued from './components/Issued.vue'
import Unpublished from './components/Unpublished.vue'

export default {
  name: 'finance_bills',
  components: {
    Issued,
    Unpublished
  },
  data() {
    return {
      active: 'issued'
    }
  },
  methods: {
    /**
     * tab被选中时触发
     *
     * @param {Object} tab 被选中的标签tab实例
     */
    handleClickTabs(tab) {
      if (tab.name === 'issued') {
        this.$refs.issued.getAdminBilleds()
      }
      if (tab.name === 'unpublished') {
        this.$refs.unpublished.getUnpublishedBillsList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  height: 100%;
  padding: 12px;
  background-color: #fff;
  /deep/.el-tabs__content {
    overflow: auto;
    height: calc(100% - 54px);
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
